import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { IApplicationState } from '../../types/redux';

/** Объявления пина, которые уже загрузил листинг. */
export function selectPinOffersInListing(
  state: Pick<IApplicationState, 'listingOffers'>,
  realtyIds: number[],
): IDailyRentOfferForMobileSite[] {
  const pinOfferIds = new Set(realtyIds);

  return state.listingOffers.offers.filter(offer => pinOfferIds.has(offer.id));
}
